<template>
  <div class="home-reports">
    <Row :gutter="8">
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 650px" :title="`资产分类数量统计饼图`">
          <Spin fix v-show="typeCount.loading"></Spin>
          <Alert type="error" v-if="typeCount.error" show-icon>获取数据失败</Alert>
          <div id="pie_asset_type_id" style="width: 100%; height: 500px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 650px" :title="`资产统计列表`">
          <Spin fix v-show="assetsCount.loading"></Spin>
          <Alert type="error" v-if="assetsCount.error" show-icon>获取数据失败</Alert>
          <Table
            v-else
            border
            size="small"
            max-height="590"
            :loading="assetsCount.loading"
            :data="assetsCount.data"
            :columns="assetsCount.columns"></Table>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 500px">
          <p slot="title">
            <span>资产流动统计</span>
            <DatePicker type="daterange"
                        size="small"
                        placement="bottom-end"
                        placeholder="选择日期范围"
                        v-model="assetFlowCount.searchDate"
                        :options="assetFlowCount.searchDateOption"
                        @on-change="searchAssetFlowDateChange"
                        separator=" ~ "
                        :clearable="false"
                        style="width: 220px; float: right; padding-right: 5px"></DatePicker>
          </p>
          <Spin fix v-show="assetFlowCount.loading"></Spin>
          <Alert type="error" v-if="assetFlowCount.error" show-icon>获取数据失败</Alert>
          <Row :gutter="16" v-else>
            <Col :lg="16">
              <div id="line_asset_flow_id" style="width: 100%; height: 400px;"></div>
            </Col>
            <Col :lg="8">
              <div id="pie_asset_flow_id" style="width: 100%; height: 400px;"></div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getAssetsType, getOpsCenterAssetsCount, getAssetsStatusTime } from '@/api/cmdb'
import echarts from '@/view/monitor/components/echarts-use.js'

export default {
  name: 'asset',
  data () {
    return {
      typeCount: {
        error: false,
        loading: false,
        total: 0,
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [],
            show: false
          },
          series: [
            {
              name: '平台',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: '{b|{b}：}{c}  {per|{d}%}\n  ',
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        }
      },
      assetsCount: {
        error: false,
        loading: false,
        data: [],
        columns: [
          {
            title: '资产类型',
            key: 'type',
            align: 'center',
            minWidth: 90
          },
          {
            title: '在库数量',
            key: 'remainder',
            align: 'center',
            minWidth: 90
          },
          {
            title: '借出数量',
            key: 'lend',
            align: 'center',
            minWidth: 90
          },
          {
            title: '维修数量',
            key: 'maintain',
            align: 'center',
            minWidth: 90
          },
          {
            title: '报废数量',
            key: 'scrap',
            align: 'center',
            minWidth: 90
          },
          {
            title: '总',
            key: 'total',
            align: 'center',
            minWidth: 90
          }
        ]
      },
      assetFlowCount: {
        lineOption: {
          tooltip: {
            trigger: 'axis',
            position: function (p) { // 其中p为当前鼠标的位置
              return [p[0] + 10, p[1] - 10]
            }
          },
          legend: {
            data: ['入库', '借出', '还回', '维修', '报废']
          },
          xAxis: {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            }
          },
          series: [
            {
              name: '入库',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            },
            {
              name: '借出',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            },
            {
              name: '还回',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            },
            {
              name: '维修',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            },
            {
              name: '报废',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            }
          ]
        },
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['入库', '借出', '还回', '维修', '报废'],
            show: false
          },
          series: [
            {
              name: '电脑出入库统计',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: '{b|{b}：}{c}  {per|{d}%}\n  ',
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        },
        searchDateOption: {
          shortcuts: [
            {
              text: '7天内',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                return [start, end]
              }
            },
            {
              text: '14天内',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
                return [start, end]
              }
            },
            {
              text: '30天内',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                return [start, end]
              }
            },
            {
              text: '90天内',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                return [start, end]
              }
            }
          ]
        },
        searchDate: '',
        datetimeAfter: '',
        datetimeBefore: '',
        loading: false,
        error: false
      }
    }
  },
  created: function () {
    this.getAssetsTypeData()
    this.getAssetsCountData()
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.assetFlowCount.searchDate = [start, end]
    let startStr = start.getFullYear() + '-' + (start.getMonth() + 1 < 10 ? '0' + (start.getMonth() + 1) : start.getMonth() + 1) + '-' + start.getDate()
    let endStr = end.getFullYear() + '-' + (end.getMonth() + 1 < 10 ? '0' + (end.getMonth() + 1) : end.getMonth() + 1) + '-' + end.getDate()
    this.assetFlowCount.datetimeAfter = startStr
    this.assetFlowCount.datetimeBefore = endStr
    this.getAssetFlows()
  },
  methods: {
    // 资产分类数量统计
    getAssetsTypeData () {
      this.typeCount.error = false
      this.typeCount.loading = true
      getAssetsType().then(res => {
        this.typeCount.pieOption.legend.data = res.data.data.map(item => item.type)
        this.typeCount.pieOption.series[0].data = res.data.data.map(item => {
          return {name: item.type, value: item.total}
        })
        let chart = echarts.init(document.getElementById('pie_asset_type_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.typeCount.pieOption, true)
        this.typeCount.loading = false
      }).catch(res => {
        this.typeCount.error = true
        this.typeCount.loading = false
        console.error(res)
      })
    },
    // 资产统计列表
    getAssetsCountData () {
      this.assetsCount.error = false
      this.assetsCount.loading = true
      getOpsCenterAssetsCount().then(res => {
        this.assetsCount.data = res.data.data
        this.assetsCount.loading = false
      }).catch(res => {
        this.assetsCount.loading = false
        this.assetsCount.error = true
        console.error(res)
      })
    },
    // 资产流动
    getAssetFlows () {
      let params = {
        start_date: this.assetFlowCount.datetimeAfter,
        end_date: this.assetFlowCount.datetimeBefore
      }
      this.assetFlowCount.error = false
      this.assetFlowCount.loading = true
      getAssetsStatusTime(params).then(res => {
        this.assetFlowCount.lineOption.xAxis.data = res.data.date_list
        this.assetFlowCount.lineOption.series[0].data = res.data.line_in_count
        this.assetFlowCount.lineOption.series[1].data = res.data.line_lend_count
        this.assetFlowCount.lineOption.series[2].data = res.data.line_return_count
        this.assetFlowCount.lineOption.series[3].data = res.data.line_maintain_count
        this.assetFlowCount.lineOption.series[4].data = res.data.line_discard_count
        let chart = echarts.init(document.getElementById('line_asset_flow_id'), 'macarons')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.assetFlowCount.lineOption, true)

        let pieFlowData = []
        for (let i in res.data.pie_flow_data) {
          pieFlowData.push({name: i, value: res.data.pie_flow_data[i]})
        }
        this.assetFlowCount.pieOption.series[0].data = pieFlowData
        let chartPie = echarts.init(document.getElementById('pie_asset_flow_id'), 'roma')
        window.addEventListener('resize', function () {
          chartPie.resize()
        })
        chartPie.clear()
        chartPie.setOption(this.assetFlowCount.pieOption, true)

        this.assetFlowCount.loading = false
      }).catch(res => {
        this.assetFlowCount.loading = false
        this.assetFlowCount.error = true
        console.error(res)
      })
    },
    searchAssetFlowDateChange (value) {
      this.assetFlowCount.datetimeAfter = value[0]
      this.assetFlowCount.datetimeBefore = value[1]
      this.getAssetFlows()
    }
  }
}
</script>

<style scoped>

</style>
